import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { CertificateHolderEmail } from '@features/certificate-holder/models/certificate-holder.model'

export function certificateHolderEmailValidator(
  currentEmails?: CertificateHolderEmail[]
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as CertificateHolderEmail | null
    const email = value?.email ?? ''

    if (email.trim() === '') {
      return null
    }

    const syntaxError = Validators.email(new FormControl(email))
    if (syntaxError !== null) {
      return syntaxError
    }
    
    if (Array.isArray(currentEmails) && currentEmails.length > 0) {
      const isDuplicate = currentEmails.some(
        e => (e.email ?? '').trim().toLowerCase() === email
      )

      if (isDuplicate) {
        return { duplicateEmail: true }
      }
    }

    return null
  }
}
